import { enMessages } from './en-US';

const frMessages = {
    "custom": {
        "teamEfficiency": "Efficacité de l'équipe",
        "teamMembers": "Membres de l'équipe",
        "dashboard": "Tableau de bord",
        "planning": "Planification",
        "info": "Info",
        "inventory": "Inventaire",
        "notifications": "Notifications",
        "help": "Aide et assistance",
        "profile": "Profil",
        "language": "Langue",
        "trend": "Tendance",
        "volume": "Le volume",
        "myTeam": "Mon équipe",
        "allTeams": "Toutes les équipes",
        "teamCalendar": "Calendrier d'équipe",
        "saveChanges": "Sauvegarder les modifications",
        "cancel": "Annuler",
        "warehouse": "Entrepôt De Café",
        "startFreeTrial": "Démarrer l'essai gratuit",
        "buyNow": "Acheter maintenant",
        "getSource": "Récupérer le code source sur GitHub",
        "demoInfo": "Cette application de démonstration est construite à l'aide des composants KendoReact suivants et du thème Meridian KendoReact.",
        "firstName": "Prénom",
        "middleName": "Deuxième nom",
        "lastName": "Nom de famille",
        "email": "Adresse e-mail",
        "phoneNumber": "Numéro de téléphone",
        "country": "Pays",
        "biography": "Biographie courte",
        "public": "Inclure dans le répertoire public",
        "team": "équipe",
        "employee": "Employé",
        "contactName": "Nom du contact",
        "jobTitle": "Titre du poste",
        "salesRepresentative": "Représentant commercial",
        "status": "Statut",
        "performance": "Performance",
        "rating":"Évaluation",
        "engagement": "Engagement",
        "budget": "Budget",
        "contacts": "Contacts",
        "address": "Adresse",
        "phone": "Téléphone",
        "gridSearch": "Rechercher dans toutes les colonnes ...",
        "exportExcel": "Exporter vers Excel",
        "exportPdf": "Exporter au format PDF",
        "inventoryItem1Description": "Éthiopie Yirgacheffe, lavée, 60 kg",
        "inventoryItem2Description": "Colombie Huila, procédé miel, 60 kg",
        "inventoryItem3Description": "Sacs kraft à valve, 12 oz",
        "inventoryItem4Description": "Brésil Cerrado, naturel, 60 kg",
        "inventoryItem5Description": "Couvercles noirs compostables, 1 000 unités",
        "supplierHighlandOrigins": "Highland Origins",
        "supplierSierraVerde": "Sierra Verde",
        "supplierPacificPack": "Pacific Pack",
        "supplierFazendaDirect": "Fazenda Direct",
        "localeEnglish": "Anglais",
        "localeFrench": "Français",
        "localeSpanish": "Espagnol",
        "openNavigation": "Ouvrir la navigation",
        "searchWarehouse": "Rechercher dans l’entrepôt",
        "openNotifications": "Ouvrir les notifications",
        "userAvatar": "Avatar utilisateur",
        "dashboardTitle": "Tableau de bord de l’entrepôt",
        "dashboardDescription": "Surveillez les performances de préparation, la capacité de l’équipe et les engagements opérationnels.",
        "dashboardLastUpdated": "Dernière mise à jour : il y a 5 minutes",
        "dashboardDataPeriod": "Période d’exemple : janv. – avr. 2020",
        "performanceSummary": "Résumé des performances de l’entrepôt",
        "ordersShippedToday": "COMMANDES EXPÉDIÉES AUJOURD’HUI",
        "ordersShippedDetail": "En hausse de 8,4 % vs hier",
        "onTimeFulfillment": "PRÉPARATION À TEMPS",
        "onTimeFulfillmentDetail": "En hausse de 1,2 point vs l’objectif",
        "pickQueue": "FILE DE PRÉPARATION",
        "pickQueueDetail": "En hausse de 9 commandes nécessitant une attention",
        "lowStockAlerts": "ALERTES DE STOCK FAIBLE",
        "lowStockAlertsDetail": "En hausse de 3 nouvelles depuis 08:00",
        "teamEfficiencyDescription": "Chiffre d’affaires des commandes (USD) par équipe pour la période sélectionnée.",
        "teamMembersDescription": "Capacité de l’équipe, engagement et budget de fonctionnement.",
        "teamTiger": "Équipe Tigre",
        "teamLemon": "Équipe Citron",
        "teamOrganic": "Équipe Bio",
        "teamOcean": "Équipe Océan",
        "schedulerTeams": "Équipes",
        "planningTitle": "Planification de l’équipe",
        "planningDescription": "Affectez les représentants commerciaux aux activités de commande planifiées.",
        "planningWorkWeek": "Semaine de travail : 27 avr. – 3 mai",
        "planningDataPeriod": "Semaine d’exemple : 27 avr. – 3 mai 2020",
        "teamCalendarDescription": "Sélectionnez les membres à inclure dans le planning partagé.",
        "includedInSchedule": "inclus dans le planning",
        "excludedFromSchedule": "exclu du planning",
        "profileTitle": "Paramètres du profil",
        "profileDescription": "Gérez vos coordonnées et vos préférences de répertoire professionnel.",
        "emailPlaceholder": "ex. : peter@gmail.com",
        "inventoryTitle": "Gestion des stocks",
        "inventoryDescription": "Suivez le café, les emballages et les fournitures dans chaque bac actif.",
        "inventoryLastUpdated": "Dernière mise à jour : 25 août 2026",
        "inventorySummary": "Résumé des stocks",
        "totalSkus": "RÉFÉRENCES TOTALES",
        "totalSkusDetail": "En hausse de 34 ajoutées ce trimestre",
        "lowStockItems": "ARTICLES À STOCK FAIBLE",
        "lowStockItemsDetail": "En hausse de 3 nécessitant une vérification aujourd’hui",
        "inventoryValue": "VALEUR DU STOCK",
        "inventoryValueDetail": "En baisse de 2,1 % vs le mois dernier",
        "inventoryOverview": "Vue d’ensemble des stocks",
        "inventoryExplanation": "Le stock disponible correspond à la quantité en stock moins les commandes engagées.",
        "createPurchaseOrder": "Créer un bon de commande",
        "searchInventory": "Rechercher dans les stocks",
        "searchInventoryPlaceholder": "Rechercher une référence, un fournisseur ou un bac",
        "inventoryEmptyTitle": "Aucun stock ne correspond à cette recherche",
        "inventoryEmptyDescription": "Essayez une autre référence, un fournisseur ou un bac, ou effacez le filtre actuel.",
        "clearInventorySearch": "Effacer la recherche",
        "sku": "Référence",
        "itemDescription": "Description de l’article",
        "onHand": "En stock",
        "reserved": "Réservé",
        "available": "Disponible",
        "bin": "Bac",
        "supplier": "Fournisseur",
        "stockStatus": "État du stock",
        "lastMovement": "Dernier mouvement",
        "outOfStock": "Rupture de stock",
        "lowStock": "Stock faible",
        "overstock": "Surstock",
        "inStock": "En stock",
        "notificationsTitle": "Notifications",
        "notificationsDescription": "Consultez les mises à jour de l’entrepôt, les exceptions de stock et les tâches planifiées.",
        "notificationsUnread": "3 non lues",
        "notificationsSection": "Notifications de l’entrepôt",
        "notificationDeliveryTitle": "Livraison de Brésil Cerrado reçue",
        "notificationDeliveryDetail": "42 sacs ont été ajoutés au bac A-02-08.",
        "notificationDeliveryTime": "Il y a 8 minutes",
        "notificationReceived": "Reçue",
        "notificationStockTitle": "Le stock de sacs kraft est sous le seuil",
        "notificationStockDetail": "Le bac P-02-11 ne contient plus aucune unité disponible.",
        "notificationStockTime": "Il y a 26 minutes",
        "notificationAttention": "Attention",
        "notificationReviewTitle": "La revue hebdomadaire de préparation est due",
        "notificationReviewDetail": "Confirmez le plan d’expédition avant 16:00.",
        "notificationReviewTime": "Hier, 09:15",
        "notificationScheduled": "Planifiée",
        "helpTitle": "Aide et assistance",
        "helpDescription": "Trouvez des conseils sur les stocks, la préparation et la planification d’équipe.",
        "searchHelpTopics": "Rechercher des sujets d’aide",
        "searchHelpTopicsPlaceholder": "Rechercher des sujets d’aide",
        "helpPurchaseQuestion": "Comment créer un bon de commande ?",
        "helpPurchaseAnswer": "Dans Stocks, sélectionnez Créer un bon de commande après avoir vérifié l’article concerné et son fournisseur.",
        "helpLowStockQuestion": "Pourquoi un article est-il marqué comme stock faible ?",
        "helpLowStockAnswer": "Stock faible signifie que la quantité disponible a atteint le seuil de réapprovisionnement après prise en compte des réservations.",
        "helpScheduleQuestion": "Comment mettre à jour un planning d’équipe ?",
        "helpScheduleAnswer": "Ouvrez Planification, sélectionnez le membre, puis créez ou modifiez une affectation dans le planificateur.",
        "notFoundTitle": "Erreur 404 : page introuvable",
        "notFoundDescription": "L’espace de travail de l’entrepôt demandé n’existe pas ou a été déplacé.",
        "goToDashboard": "Accéder au tableau de bord",
        "online": "En ligne",
        "offline": "Hors ligne",
        "validationEmail": "Vous avez saisi une adresse e-mail invalide !",
        "validationRequired": "Ce champ est obligatoire",
        "validationPhone": "Saisissez un numéro de téléphone valide.",
        "validationBiography": "La biographie doit comporter au moins 50 caractères.",
        "masterReactUi": "Maîtrisez l’art des interfaces React",
        "kendokaIllustration": "Illustration Kendoka",
        "githubIcon": "Icône GitHub"
    },
    "grid":{
        "groupPanelEmpty": "Faites glisser un en-tête de colonne et déposez-le ici pour grouper par cette colonne",
        "pagerItemsPerPage": "éléments par page",
        "pagerInfo": "{0} - {1} sur {2} éléments",
        "pagerFirstPage": "Aller à la première page",
        "pagerPreviousPage": "Aller à la page précédente",
        "pagerNextPage": "Aller à la page suivante",
        "pagerLastPage": "Aller à la dernière page",
        "pagerPage": "Page",
        "pagerOf": "de",
        "filterEqOperator": "Est égal à",
        "filterNotEqOperator": "N'est pas égal à",
        "filterIsNullOperator": "Est nulle",
        "filterIsNotNullOperator": "Est non nulle",
        "filterIsEmptyOperator": "Est vide",
        "filterIsNotEmptyOperator": "N'est pas vide",
        "filterStartsWithOperator": "Commence par",
        "filterContainsOperator": "Contient",
        "filterNotContainsOperator": "Ne contient pas",
        "filterEndsWithOperator": "Se termine par",
        "filterGteOperator": "Est supérieur ou égal à",
        "filterGtOperator": "Est supérieur à",
        "filterLteOperator": "Est inférieur ou égal à",
        "filterLtOperator": "Est inférieur à",
        "filterIsTrue":"Est vrai",
        "filterIsFalse": "Est faux",
        "filterBooleanAll": "(Tous)",
        "filterAfterOrEqualOperator": "Est postérieur ou égal à",
        "filterAfterOperator": "Est postérieur",
        "filterBeforeOperator": "Est antérieur",
        "filterBeforeOrEqualOperator": "Est antérieur ou égal à",
        "noRecords": "Aucun enregistrement disponible.",
        "filterSubmitButton": "Filtre",
        "filterClearButton": "Effacer",
        "filterAndLogic": "Et",
        "filterOrLogic": "Ou alors",
        "filterTitle": "Filtre",
        "sortAscending": "Trier par ordre croissant",
        "sortDescending": "Trier par ordre décroissant"
    },
    "dateinput":{
        "increment": "Augmenter la valeur",
        "decrement": "Diminuer la valeur"
    },
    "calendar":{
        "today":"AUJOURD'HUI"
    },
    "datepicker":{
        "toggleCalendar": "Basculer le calendrier"
    },
    "dropdowns":{
        "nodata": "AUCUNE DONNÉE DISPONIBLE.",
        "clear": "Effacer"
    },
    "numerictextbox":{
        "increment": "Augmenter la valeur",
        "decrement": "Diminuer la valeur"
    },
    "upload": {
        "cancel": "Annuler",
        "clearSelectedFiles": "Effacer",
        "dropFilesHere": "Déposer des fichiers ici pour télécharger",
        "headerStatusUploaded": "Terminé",
        "headerStatusUploading": "Téléchargement...",
        "invalidFileExtension": "Type de fichier non autorisé.",
        "invalidFiles": "Fichier(s) invalide(s). Veuillez vérifier les exigences de téléchargement de fichier.",
        "invalidMaxFileSize": "La taille du fichier est trop grande.",
        "invalidMinFileSize": "La taille du fichier est trop petite.",
        "remove": "Retirer",
        "retry": "Réessayez",
        "select": "Sélectionnez les fichiers...",
        "uploadSelectedFiles": "Télécharger",
        "total": "Total",
        "files": "fichiers"
    },
    "sortable": {
        "noData": "Aucune donnée"
    },
    "scheduler": {
        "editorValidationRequired": "Champ requis.",
        "editorValidationStart": "L'heure de début doit être antérieure à l'heure de fin.",
        "editorValidationEnd": "L'heure de fin doit être postérieure à l'heure de début.",
        "allEvents": "Tous les évènements",
        "allDay": "toute la journée",
        "today": "Aujourd'hui",
        "dayViewTitle": "Journée",
        "monthViewTitle": "Mois",
        "weekViewTitle": "La semaine",
        "workWeekViewTitle": "Semaine de travail",
        "timelineViewTitle": "Chronologie",
        "agendaViewTitle": "Ordre du jour",
        "deleteTitle": "Supprimer",
        "previousTitle": "Précédent",
        "nextTitle": "Suivant",
        "showFullDay": "Afficher toute la journée",
        "showWorkDay": "Afficher les heures d'ouverture",
        "editorOccurrence": "Modifier l'occurrence actuelle",
        "editorSeries": "Modifier la série",
        "editorRecurringConfirmation": "Voulez-vous modifier uniquement cette occurrence d'événement ou toute la série?",
        "editorRecurringDialogTitle": "Modifier l'élément récurrent",
        "editorSave": "Enregistrer",
        "editorCancel": "Annuler",
        "editorDelete": "Supprimer",
        "editorTitle": "Événement",
        "editorEventTitle": "Titre",
        "editorEventStart": "Démarrer",
        "editorEventStartTimeZone": "Fuseau horaire de début",
        "editorEventEnd": "Fin",
        "editorEventEndTimeZone": "Fuseau horaire de fin",
        "editorEventAllDay": "Événement toute la journée",
        "editorEventDescription": "Description",
        "editorEventSeparateTimeZones": "Terminer dans un fuseau horaire différent",
        "editorEventTimeZone": "Spécifier le fuseau horaire",
        "recurrenceEditorRepeat": "Répéter",
        "recurrenceEditorDailyInterval": "jour (s)",
        "recurrenceEditorDailyRepeatEvery": "Répéter chaque",
        "recurrenceEditorWeeklyInterval": "semaine (s)",
        "recurrenceEditorWeeklyRepeatEvery": "Répéter chaque",
        "recurrenceEditorWeeklyRepeatOn": "Répéter",
        "recurrenceEditorMonthlyDay": "Jour",
        "recurrenceEditorMonthlyInterval": "mois (s)",
        "recurrenceEditorMonthlyRepeatEvery": "Répéter chaque",
        "recurrenceEditorMonthlyRepeatOn": "Répéter",
        "recurrenceEditorYearlyOf": "of",
        "recurrenceEditorYearlyRepeatEvery": "Répéter chaque",
        "recurrenceEditorYearlyRepeatOn": "Répéter",
        "recurrenceEditorYearlyInterval": "année (s)",
        "recurrenceEditorFrequenciesDaily": "Du quotidien",
        "recurrenceEditorFrequenciesMonthly": "Mensuel",
        "recurrenceEditorFrequenciesNever": "Jamais",
        "recurrenceEditorFrequenciesWeekly": "Hebdomadaire",
        "recurrenceEditorFrequenciesYearly": "Annuel",
        "recurrenceEditorOffsetPositionsFirst": "Premier",
        "recurrenceEditorOffsetPositionsSecond": "Deuxième",
        "recurrenceEditorOffsetPositionsThird": "Troisième",
        "recurrenceEditorOffsetPositionsFourth": "Quatrième",
        "recurrenceEditorOffsetPositionsLast": "Dernier",
        "recurrenceEditorWeekdaysDay": "Journée",
        "recurrenceEditorWeekdaysWeekday": "Jour de la semaine",
        "recurrenceEditorWeekdaysWeekendday": "Jour de weekend",
        "recurrenceEditorEndAfter": "Après",
        "recurrenceEditorEndOccurrence": "occurrence (s)",
        "recurrenceEditorEndLabel": "Fin",
        "recurrenceEditorEndNever": "Jamais",
        "recurrenceEditorEndOn": "On",
        "deleteConfirmation": "Voulez-vous vraiment supprimer cet événement?",
        "deleteRecurringConfirmation": "Souhaitez-vous supprimer uniquement cette occurrence d'événement ou toute la série?",
        "deleteOccurrence": "Supprimer l'occurrence actuelle",
        "deleteSeries": "Supprimer la série",
        "deleteDialogTitle": "Supprimer l'événement",
        "deleteRecurringDialogTitle": "Supprimer l'élément récurrent",
        "dateTitle": "Date",
        "timeTitle": "Temps",
        "eventTitle": "Un événement",
        "noEvents": "Aucun événement",
    }
};

const completeFrMessages = Object.keys(enMessages).reduce((messages, key) => ({
    ...messages,
    [key]: {
        ...enMessages[key],
        ...(frMessages[key] || {})
    }
}), {});

export { completeFrMessages as frMessages };